import { ServiceValues } from '../values/ServiceValues';
import { ServiceAxios } from './ServiceEW';
import { Values } from '../values/Values';

async function getAllInsumos(limit, page) {
  try {
    const timeout = ServiceValues.timeout;
    const baseUrl = ServiceValues.base_url_local;
    const api = ServiceAxios(baseUrl, timeout);
    const params = {
      limit: limit,
    };
    const dados = await api.get('insumos/', { params: params });
    if (dados) {
      if (dados.data) {
        return dados.data;
      }
      else {
        return {
          isSuccess: false,
          message: Values.MessageValues.erro_catch,
          result: []
        }
      }
    }
    else {
      return {
        isSuccess: false,
        message: Values.MessageValues.erro_catch,
        result: []
      };
    }

  } catch (e) {
    return {
      isSuccess: false,
      message: Values.MessageValues.erro_catch,
      result: []
    };

  }
}

async function fabricarInsumos(idUsuario, insumosOrigem, insumosDestino) {
  try {
    const timeout = ServiceValues.timeout;
    const baseUrl = ServiceValues.base_url_local;
    const api = ServiceAxios(baseUrl, timeout);
    const body = {
      idUsuario: idUsuario,
      insumosOrigem: insumosOrigem,
      insumosDestino: insumosDestino
    };
    const dados = await api.post('insumos/fabricar-insumos', body);
    if (dados) {
      if (dados.data) {
        return dados.data;
      }
      else {
        return {
          isSuccess: false,
          message: Values.MessageValues.erro_catch,
          result: []
        }
      }
    }
    else {
      return {
        isSuccess: false,
        message: Values.MessageValues.erro_catch,
        result: []
      };
    }

  } catch (e) {
    return {
      isSuccess: false,
      message: Values.MessageValues.erro_catch,
      result: []
    };

  }
}



export {getAllInsumos, fabricarInsumos};
